<template>
  <a-card :bordered="false" class="m-t-10">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      创建调拨单
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="调入经销商" name='allocation_to_id'>
        <a-input placeholder="请选择调入经销商" style="width: 380px;margin-right: 10px;" readonly v-model:value="form.allocation_to_name"></a-input>
        <a-button type="primary" @click="showDealer = true;dealerType = 'callIn'">选择</a-button>
      </a-form-item>
      <a-form-item label="调出经销商" name='allocation_from_id'>
        <a-input placeholder="请选择调出经销商" style="width: 380px;margin-right: 10px;" readonly v-model:value="form.allocation_from_name"></a-input>
        <a-button type="primary" @click="showDealer = true;dealerType = 'callOut'" :disabled="!form.allocation_to_name">选择</a-button>
      </a-form-item>
      <a-form-item label="订单备注">
        <a-textarea v-model:value="form.remark" style='width: 40%;' placeholder="请输入订单备注" :rows="4" :maxlength='100' />
      </a-form-item>
      <a-form-item label="商品" name='goodList'>
        <a-button type="primary" @click='openGood' :disabled="!form.allocation_from_name"><PlusOutlined />添加商品</a-button>
        <a-table class='m-t-20' :pagination='false' :loading='loading' bordered rowKey='product_sn' :columns='columns'  :data-source='goodList'>
          <template v-slot:gift_name="{ record }">
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
              </template>
              <template #description>
                <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
              </template>
            </a-card-meta>
          </template>
          <template v-slot:num="{ record }">
            <a-input-number style='width: 100%;' v-model:value="record.num" :precision='0' :min='1' :max='record.product_num' placeholder='请输入数量' /><p v-if='record.fail' style='color:#ff4d4f'>请输入调拨数量！</p>
          </template>
          <template v-slot:action="{ index }">
            <a-button type="link" @click='delGood(index)'>删除</a-button>
          </template>
        </a-table>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
        <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">取消</a-button>
        <a-button class="width-100" block type="primary" @click="onSubmit">保存</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-modal :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null"
    destroyOnClose>
    <selectDealer :checkout='false' v-on:select="dealerSelect" :selectList="[{id:dealerType == 'callOut'?form.call_out_dealer_id:form.call_out_dealer_id}]"></selectDealer>
  </a-modal>
  <a-modal  :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <dealerGoods :id='form.allocation_from_id' v-on:select="goodSelect" :selectList='goodList' :checkout="true"></dealerGoods>
  </a-modal>
</template>

<script>
  import { ref, inject, reactive, toRefs } from "vue";
  import { LeftOutlined,PlusOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { addAllocation,getAllocationDealerGoods } from '@/api/antiFleeing';
  import { iscode } from "@/utils/app";
  import store from "@/store"; 
  import dealerGoods from '../../components/dealerGoods.vue' 
  let defForm = {
    allocation_to_id: '',
    allocation_from_id: '',
    remark:'',
    product:[]
  };
  export default {
    components: { LeftOutlined,PlusOutlined,dealerGoods },
    setup() {
      const ruleForm = ref();
      const form = ref({ ...defForm });
      let goodList = async () => {
        if (!state.goodList.length) {
          return Promise.reject('请选择商品!');
        } else {
          return Promise.resolve();
        }
      };
      const state = reactive({
        labelCol: {span: 3},
        wrapperCol: {span: 21},
        info: store.state.user.info,
        dealerType: '', //选择经销商类型 callIn调入 callOut调出
        showDealer: false, 
        showGood:false,
        goodList: [],
        loading:false,
        rules: {
          allocation_to_id: [
            { required: true, message: '请选择调入经销商',type:'number'}
          ],
          allocation_from_id: [
            { required: true, message: '请选择调出经销商',type:'number'}
          ],
          goodList:[
            { required: true, validator: goodList}
          ]
        }
      });
      const columns = [
        {
          title: "商品编码",
          dataIndex: "product_sn",
          key: "product_sn"
        },
        {
          title: "商品信息",
          dataIndex: "gift_name",
          key: "gift_name",
          slots: { customRender: "gift_name" },
        },
        {
          title: "规格",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          customRender:({record})=>{
            return record.product_sku_name ? record.product_sku_name:'单规格'
          } 
        },
        {
          title: "库存量",
          dataIndex: "product_num",
          key: "product_num"
        },
        {
          title: "调拨数量",
          dataIndex: "num",
          key: "num",
          slots: { customRender: "num" },
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        }
      ];
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      //数字判断
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      //选择经销商
      const dealerSelect = (e) => {
        if(state.dealerType == 'callOut'){
          form.value.allocation_from_id = e.dealer_id;
          form.value.allocation_from_name = e.dealer_name;
        }else{
          form.value.allocation_to_id = e.dealer_id;
          form.value.allocation_to_name = e.dealer_name;
          form.value.allocation_from_id = '';
          form.value.allocation_from_name = '';
          state.goodList = [];
        }
        state.showDealer = false;
      }
      // 打开选择商品
      const openGood = () =>{
        if(form.value.allocation_from_id == form.value.allocation_to_id){
          $Modal.info({
            centered: true,
            title: '调入经销商和调出经销商需不同，暂不支持同经销商调拨',
          })
          return
        }
        state.showGood = true
      }
      //选择商品
      const goodSelect = (e) => {
        state.goodList = e
        state.showGood = false
      }
      //删除商品
      const delGood = (index) => {
        state.goodList.splice(index, 1)
      }
      //提交
      const onSubmit = () => {
        form.value.product = []
        state.goodList.forEach(v=>{
          v.fail = false
          if(!isNumber(v.num)){
            v.fail = true
          } 
          form.value.product.push(v.product_id+'_'+(v.product_sku_sn?v.product_sku_sn:0)+'_'+(v.num?v.num:0))
        })
        ruleForm.value.validate().then(() => {
          if(state.goodList.findIndex(v=> v.fail ) !== -1){
            message.error('请输入调拨数量!');
            return false
          }
          $Modal.confirm({
            centered: true,
            title: '确认生成调拨单？',
            content: '保存后商品信息将无法修改',
            async onOk() {
              const hide = message.loading("正在加载中...", 0);
              let res = await addAllocation({ ...form.value }).then((res) => res.data).catch(error => error);
              if (iscode(res)) {
                message.success(res.msg);
                setTimeout(() => {
                  $router.go(-1);
                }, 2000);
              } else {
                message.error(res.msg);
              }
              setTimeout(hide);
            }
          })
        }).catch(error => {
          message.error('请完善表单！');
        });
      };
      return {
        form,
        ruleForm,
        ...toRefs(state),
        columns,
        onSubmit,
        dealerSelect,
        goodSelect,
        delGood,
        openGood
      };
    },
  };
</script>